<template>
  <div class="page">
    <commonHeader heading="信息加工有效评估" subtitle="全部数据">
      <template v-slot:icon>
        <span class="iconfont icon-fanhui back" @click="goBack()"></span>
      </template>
    </commonHeader>
    <!-- 信息加工有效评估全部数据 -->
    <!-- <div class="big-title">
      <div class="left-title">信息加工有效评估全部数据</div>
    </div> -->
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="信息加工方式" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="资源名称" hide-details solo
            clearable></v-text-field>
            <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="任务名称" hide-details solo
            clearable></v-text-field>
          <v-btn depressed color="primary">
            搜索
          </v-btn>
          <v-btn depressed>
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table hide-default-footer :headers="headers" :items="desserts" :items-per-page="5"
            class="elevation-1"></v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination class="table-pagination" prev-icon="fa fa-angle-left" next-icon="fa fa-angle-right"
            color="#4caf50" :value="pagination.page" :length="1" circle :total-visible="7"></v-pagination>
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      selectMetaListData: [{ text: '水电费', value: 1 }, { text: '让突然', value: 2 }],

      dateMenu: false,
      headers: [
        {
          text: '信息加工方式',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: '资源专业归属', value: 'calories' },
        { text: '资源名称', value: 'fat' },
        { text: '任务引用次数', value: 'carbs' },
        { text: '资源收藏人数', value: 'protein' },
        { text: '累计浏览人次', value: 'val1' },
        { text: '知识点关联测试得分率', value: 'val2' },
        { text: '引用任务完学率', value: 'val3' },
      ],
      desserts: [
        {
          name: '仿真互动',
          calories: '电力技术类',
          fat: '油浸式变压器',
          carbs: 24,
          protein: 6523,
          val1: 6932,
          val2: '80%',
          val3: 1.0,
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
        // name: "",
        perPageOptions: [8, 12, 16, 20],
      },


    };
  },

  created() {

  },

  mounted() {
    this.getTableList()
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'InfoProcessing',
      });
    },
    getTableList() { },

  }
}
</script>

<style scoped>
.page {
  padding: 0 15px;

  .big-title {
    display: flex;
    margin: 0 5px;
    height: 45px;
    line-height: 45px;

    .left-title {
      font-size: 16px;
      flex: 1;
      text-align: left;
    }

    .right-return {
      text-align: right;
      font-size: 18px;
    }
  }

  .table-data {
    .v-card {
      padding: 10px;
    }

    .table-header {
      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }

    .table-content {
      padding: 10px 0;
    }

    .table-paging {
      overflow: hidden;
      text-align: right;

      .table-pagination {
        float: right;
      }
    }
  }
}
</style>